"use client";

import { HugeiconsIcon } from "@hugeicons/react";
import { File02Icon } from "@hugeicons-pro/core-stroke-rounded";
import type { FC } from "react";

type Props = {
  color?: string;
};

const FileIcon: FC<Props> = ({ color = "currentColor" }) => (
  <HugeiconsIcon icon={File02Icon} size={12} color={color} />
);

export default FileIcon;
